import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import type { RootState } from './Store';
import { getRatingApi } from '../utils/clientapi';
import type { PostCollectionResourceRatingPostRequest } from 'mml-client-api';

export interface RatingSliceState {
	added: boolean;
	submitted: boolean;
}

const initialState: RatingSliceState = {
	added: false,
	submitted: false
};

type AddRatingResult = void;

type AddRatingArgs = number;

export const addRating = createAsyncThunk<
	AddRatingResult,
	AddRatingArgs,
	{ state: RootState }
>(
	'rating/addRating',
	async (arg: AddRatingArgs, thunkApi): Promise<AddRatingResult> => {
		const { configuration } = thunkApi.getState();
		const value = arg;

		const api = getRatingApi(configuration);
		const requestParameters: PostCollectionResourceRatingPostRequest = {
			ratingRequestBody: {
				value
			}
		};

		await api.postCollectionResourceRatingPost(requestParameters);
	}
);

const ratingSlice = createSlice({
	name: 'rating',
	initialState,
	reducers: {
		resetRating: () => initialState
	},
	extraReducers: (builder) => {
		builder
			.addCase(addRating.pending, (state) => {
				state.added = true;
			})
			.addCase(addRating.fulfilled, (state) => {
				state.submitted = true;
			});
	}
});

export const { resetRating } = ratingSlice.actions;
export default ratingSlice.reducer;
